module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc11-15564981856a2b7d4c99de3862b2a4ac.jpg";